import { useEffect, useRef, useState } from 'react'

const poster = '/projects/lessms/covers-tilted-v1.avif'
const mp4Movie = '/projects/lessms/covers-tilted-v1.mp4'
const webmMovie = '/projects/lessms/covers-tilted-v2.webm'

export const HomeLessMsPromo = () => {
  const card = useRef<HTMLDivElement>(null)
  const video = useRef<HTMLVideoElement>(null)
  const [inView, setInView] = useState(false)
  const [motionAllowed, setMotionAllowed] = useState(false)
  const [movie, setMovie] = useState(mp4Movie)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function' || typeof IntersectionObserver === 'undefined') return
    if (video.current?.canPlayType('video/webm; codecs="vp9"')) setMovie(webmMovie)
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)')
    const updatePreference = () => setMotionAllowed(!preference.matches)
    updatePreference()
    preference.addEventListener('change', updatePreference)
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting))
    if (card.current) observer.observe(card.current)
    return () => {
      observer.disconnect()
      preference.removeEventListener('change', updatePreference)
    }
  }, [])

  useEffect(() => {
    if (!video.current) return
    if (inView && motionAllowed) void video.current.play().catch(() => {})
    else video.current.pause()
  }, [inView, motionAllowed, movie])

  return (
    <div ref={card} data-project="lessms" className="relative mt-3 min-h-[133px] overflow-hidden rounded-[16px] bg-[#111111] px-4 py-3 text-white">
      <div className="pointer-events-none absolute inset-y-0 left-[44%] w-[66%] overflow-hidden" aria-hidden="true">
        <img src={poster} alt="" width={720} height={480} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
        <video ref={video} onError={() => setMovie(mp4Movie)} src={inView && motionAllowed ? movie : undefined} poster={poster} width={720} height={480} muted loop playsInline preload="none" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,#111111_0%,rgba(17,17,17,0.85)_15%,transparent_70%)]" />
      </div>
      <div className="relative z-10 flex max-w-[260px] flex-col items-start gap-[18px]">
        <p className="font-['Familjen_Grotesk'] text-[22px] font-normal leading-[23.76px] tracking-[-0.44px] text-white">
          Less ms &mdash; find games by meaning, in milliseconds.
        </p>
        <a href="https://lessms.gosha.ee/" target="_blank" rel="noreferrer" aria-label="Explore Less ms (opens in new tab)" className="inline-flex items-center justify-center rounded-[8px] bg-white px-4 py-2.5 text-center text-[15px] font-medium leading-[22.5px] tracking-[-0.15px] text-black transition-[background-color,transform] duration-150 hover:bg-white/92 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#111111]">
          Explore
        </a>
      </div>
    </div>
  )
}
